import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Select from 'react-virtualized-select';

import { Collapse, Input, DatePicker } from 'antd';
import { MASCARA_DDMMYYYY, MASCARA_YYYYMMDD, convertirTextAMomentUTC } from '../../commons/gestioDates';
import PopoverError from '../commons/popoverError';
import VariableLlista from '../commons/variableLlista';

import {
    usuariIntroduccioModificarCamp
} from '../../actions';
import {
    selectorFormulariDadesEsActiu,
    selectorFormulariDadesEditades,
    selectorRolsOrdenatsAlfabeticament,
    selectorFormulariDadesEstacions,
    selectorFormulariErrors
} from '../../selectors/selector_usuari';
import {
    selectorMunicipis
} from '../../selectors/selector_municipis';

import { textQuanNoHiHaDada } from '../../constants';

const Panel = Collapse.Panel;

const nomCampMunicipi = 'codiINEMunicipi';

const renderitzarCampTipusData = (nomCamp, esEditable, valor, usuariIntroduccioModificarCamp) => {
    const dataSeleccionadaText = valor;
    const dataSeleccionada = dataSeleccionadaText ? convertirTextAMomentUTC(dataSeleccionadaText, MASCARA_YYYYMMDD) : null;

    if (!esEditable) {
        return dataSeleccionada ? dataSeleccionada.format(MASCARA_DDMMYYYY) : textQuanNoHiHaDada;
    }

    return <DatePicker
        className='usuari-formulari-data'
        defaultValue={dataSeleccionada}
        onChange={(date) => {
            const dataText = date ? date.format(MASCARA_YYYYMMDD) : null;
            usuariIntroduccioModificarCamp(nomCamp, dataText);
        }}
        format={MASCARA_DDMMYYYY} />;
};

const renderitzarCampTipusLlista = (nomCamp, esEditable, valor, valorsPossibles, usuariIntroduccioModificarCamp) => {
    if (!esEditable) {
        return valorsPossibles.find((valorPossible) => valorPossible.id === valor).valor;
    }

    const estilsSelector = {
        selector: 'usuari-llistat-selector'
    };
    const variable = {id: nomCamp, nom: null, valor, valorsPossibles};

    return (
        <VariableLlista
            estils={estilsSelector}
            variable={variable}
            onChangeValorVariable={(valor) => usuariIntroduccioModificarCamp(nomCamp, valor)}
            allowClear={false}
        />
    );

};

const renderitzarCampTipusText = (nomCamp, esEditable, valor, usuariIntroduccioModificarCamp) => {
    if (!esEditable) {
        // si hi ha valor, sempre es passa a string perquè així ens assegurem que si és una variable booleana aparegui
        return valor ? valor.toString() : textQuanNoHiHaDada;
    }

    return <Input
        defaultValue={valor}
        onBlur={(event) => {
            const valor = event.target.value;
            usuariIntroduccioModificarCamp(nomCamp, valor ? valor : null);
        }}
    />;
};

const renderitzarLlistatEstacions = (estacions) => {
    if (estacions.length === 0) {
        return <div className='usuari-estacions-associades-sense-dades'>No té estacions associades</div>;
    }

    return <ul>
        {estacions.map((estacio, index) => {
            return <li key={index}>{estacio.nom}</li>;
        })}
    </ul>;
};

const renderitzarError = (errorCamp) => {
    if (errorCamp) {
        return <PopoverError contingut={errorCamp} classNameIcona='icona-error' />;
    }

    // és necessari retornar un div buit i no null perquè cssGrid ho interpreti com a contingut
    return <div></div>;
};

const obtenirRolsAmbFormatPelSelector = rols => rols.map(rol => ({id: rol.id, valor: rol.nom }));

const obtenirMunicipisAmbFormatPelSelector = (municipis) => {
    return Object.keys(municipis).map(codiINEMunicipi => {
        const municipiSeleccionat = municipis[codiINEMunicipi];
        const nomMunicipi = municipiSeleccionat ? municipiSeleccionat.nom : null;
        return { value: codiINEMunicipi, label: nomMunicipi, className: 'Select-outer-item' };
    });
};

class UsuariFormulari extends Component {

    renderitzarComponentSegonsTipus(nomCamp, esEditable, tipusCamp, valorsPossibles) {
        const  { dades, usuariIntroduccioModificarCamp } = this.props;
        const valor = dades[nomCamp];

        switch (tipusCamp) {
            case 'text': {
                return renderitzarCampTipusText(nomCamp, esEditable, valor, usuariIntroduccioModificarCamp);
            }

            case 'llista': {
                return renderitzarCampTipusLlista(nomCamp, esEditable, valor, valorsPossibles, usuariIntroduccioModificarCamp);
            }

            case 'data': {
                return renderitzarCampTipusData(nomCamp, esEditable, valor, usuariIntroduccioModificarCamp);
            }

            default:
                return null;
        }
    }

    renderitzarComponentText(nomCamp, esEditable) {
        return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, 'text');
    }

    renderitzarComponentLlista(nomCamp, valorsPossibles, esEditable) {
        return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, 'llista', valorsPossibles);
    }

    renderitzarComponentData(nomCamp, esEditable) {
        return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, 'data');
    }

    renderitzarCampMunicipi() {
        const { dades, municipis, esEditable, usuariIntroduccioModificarCamp } = this.props;
        const codiINEMunicipiSeleccionat = dades[nomCampMunicipi];

        if (!esEditable) {
            return municipis[codiINEMunicipiSeleccionat].nom;
        }

        const municipisAmbFormatPelSelector = obtenirMunicipisAmbFormatPelSelector(municipis);

        return (
            <Select
                options={municipisAmbFormatPelSelector}
                simpleValue
                placeholder={null}
                noResultsText='Municipi no trobat'
                className='usuari-llistat-selector'
                value={codiINEMunicipiSeleccionat}
                onChange={valor => usuariIntroduccioModificarCamp(nomCampMunicipi, valor)}
                clearable={false}
                maxHeight={100}
            />
        );

    }

    renderitzarCampComarca() {
        const { dades, municipis } = this.props;
        const codiINEMunicipiSeleccionat = dades[nomCampMunicipi];

        if (!codiINEMunicipiSeleccionat) {
            return textQuanNoHiHaDada;
        }

        const municipiSeleccionat = municipis[codiINEMunicipiSeleccionat];
        const nomComarcaSeleccionada = municipiSeleccionat && municipiSeleccionat.comarca ? municipiSeleccionat.comarca.nom : textQuanNoHiHaDada;
        return nomComarcaSeleccionada;
    }

    renderitzarComponentEstat() {
        const { esActiu } = this.props;
        const estatAMostrar = esActiu ? 'Actiu' : 'Inactiu';
        return estatAMostrar;
    }

    renderitzarSeccioEstacionsAssociades() {
        const { estacions } = this.props;

        const estacionsAgrupadesPerActivitat = _.groupBy(estacions, 'esActiva');

        const estacionsActives = estacionsAgrupadesPerActivitat[true] || [];
        const estacionsInactives = estacionsAgrupadesPerActivitat[false] || [];

        return <Panel header={'Estacions associades'}>
            <div className='usuari-formulari-columna estacions-associades'>
                <div>
                    <div className='usuari-formulari-bloc-text-noerror'>
                        <span>Estacions actives:</span>
                        {renderitzarLlistatEstacions(estacionsActives)}
                    </div>
                </div>
                <div>
                    <div className='usuari-formulari-bloc-text-noerror'>
                        <span>Estacions inactives:</span>
                        {renderitzarLlistatEstacions(estacionsInactives)}
                    </div>
                </div>
            </div>
        </Panel>;
    }

    renderitzarSeccioDadesContacte() {
        const { esEditable, errors } = this.props;
        const errorCampNom = errors['nom'];
        const errorCampTelefon = errors['telefon'];
        const errorCampEmail = errors['email'];
        const errorCampCodiINEMunicipi = errors[nomCampMunicipi];
        const errorCampCodiPostal = errors['codiPostal'];
        const hiHaErrorsEnLaSeccio = errorCampNom || errorCampTelefon || errorCampEmail
            || errorCampCodiINEMunicipi || errorCampCodiPostal;
        const errorsSeccio = hiHaErrorsEnLaSeccio ? 'Hi ha algun amb error a la secció': null;

        return <Panel header={<div>{'Dades de contacte'}&nbsp;&nbsp;&nbsp;{renderitzarError(errorsSeccio)}</div>} className='camp'>
            <div className='usuari-formulari-columna usuari-dades-contacte'>
                <div>
                    <div className='usuari-formulari-bloc-text'>
                        <span>Nom:</span>
                        <div>{this.renderitzarComponentText('nom', esEditable)}</div>
                        {renderitzarError(errorCampNom)}
                    </div>
                    <div className='usuari-formulari-bloc-text'>
                        <span>Primer cognom:</span>
                        <div>{this.renderitzarComponentText('cognom1', esEditable)}</div>
                    </div>
                    <div className='usuari-formulari-bloc-text'>
                        <span>Segon cognom:</span>
                        <div>{this.renderitzarComponentText('cognom2', esEditable)}</div>
                    </div>
                    <div className='usuari-formulari-bloc-text'>
                        <span>Telèfon:</span>
                        <div>{this.renderitzarComponentText('telefon', esEditable)}</div>
                        {renderitzarError(errorCampTelefon)}
                    </div>
                    <div className='usuari-formulari-bloc-text'>
                        <span>Correu electrònic:</span>
                        <div className='usuari-email'>{this.renderitzarComponentText('email', esEditable)}</div>
                        {renderitzarError(errorCampEmail)}
                    </div>
                </div>
                <div>
                    <div className='usuari-formulari-bloc-text-noerror'>
                        <span>Carrer:</span>
                        <div>{this.renderitzarComponentText('carrer', esEditable)}</div>
                    </div>
                    <div className='usuari-formulari-bloc-text-noerror usuari-adreca'>
                        <span>Número:</span>
                        <div>{this.renderitzarComponentText('numero', esEditable)}</div>
                        <span className='usuari-pis'>Pis:</span>
                        <div>{this.renderitzarComponentText('pis', esEditable)}</div>
                        <span className='usuari-porta'>Porta:</span>
                        <div>{this.renderitzarComponentText('porta', esEditable)}</div>
                    </div>
                    <div className='usuari-formulari-bloc-text-noerror usuari-cp'>
                        <span>Codi postal:</span>
                        <div>{this.renderitzarComponentText('codiPostal', esEditable)}</div>
                        {renderitzarError(errorCampCodiPostal)}
                        <span>Municipi:</span>
                        <div>{this.renderitzarCampMunicipi()}</div>
                        {renderitzarError(errorCampCodiINEMunicipi)}
                    </div>
                    <div className='usuari-formulari-bloc-text-noerror usuari-comarca'>
                        <span>Comarca:</span>
                        <div>{this.renderitzarCampComarca()}</div>
                    </div>
                </div>
            </div>
        </Panel>;
    }

    renderitzarSeccioDadesUsuari() {
        const { esEditable, errors, rols } = this.props;
        const rolsAmbFormatPelSelector = obtenirRolsAmbFormatPelSelector(rols);

        return <div className='usuari-formulari-seccio-dades-usuari camp'>
            <div className='usuari-formulari-columna usuari-dades-generals'>
                <div>
                    <div className='usuari-formulari-bloc-text'>
                        <span>Codi:</span>
                        <div>{this.renderitzarComponentText('codi', esEditable)}</div>
                        {renderitzarError(errors['codi'])}
                    </div>
                    <div className='usuari-formulari-bloc-text'>
                        <span>Rol:</span>
                        <div>{this.renderitzarComponentLlista('idRol', rolsAmbFormatPelSelector, esEditable)}</div>
                        {renderitzarError(errors['idRol'])}
                    </div>
                </div>
                <div>
                    <div className='usuari-formulari-bloc-data'>
                        <span>{'Data d\'alta:'}</span>
                        <div>{this.renderitzarComponentData('dataAlta', esEditable)}</div>
                        {renderitzarError(errors['dataAlta'])}
                    </div>
                    <div className='usuari-formulari-bloc-data'>
                        <span>Data de baixa:</span>
                        <div>{this.renderitzarComponentData('dataBaixa', esEditable)}</div>
                        {renderitzarError(errors['dataBaixa'])}
                    </div>
                </div>
                <div>
                    <div className='usuari-formulari-bloc-text-noerror usuari-estat'>
                        <span>Estat:</span>
                        <div>{this.renderitzarComponentEstat()}</div>
                    </div>
                </div>
            </div>
        </div>;
    }

    render() {
        return (
            <div className='usuari-formulari requadre-arrodonit-gris'>
                {this.renderitzarSeccioDadesUsuari()}
                <div className='usuari-formulari-collapse scrollable camp'>
                    <Collapse>
                        {this.renderitzarSeccioDadesContacte()}
                        {this.renderitzarSeccioEstacionsAssociades()}
                    </Collapse>
                </div>
            </div>
        );
    }
}

UsuariFormulari.propTypes = {
    esEditable: PropTypes.bool,
    esActiu: PropTypes.bool,
    dades: PropTypes.object,
    municipis: PropTypes.object,
    rols: PropTypes.array,
    estacions: PropTypes.array,
    errors: PropTypes.object,
    usuariIntroduccioModificarCamp: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        esActiu: selectorFormulariDadesEsActiu(state),
        dades: selectorFormulariDadesEditades(state),
        municipis: selectorMunicipis(state),
        rols: selectorRolsOrdenatsAlfabeticament(state),
        estacions: selectorFormulariDadesEstacions(state),
        errors: selectorFormulariErrors(state)
    };
};

export default connect(mapStateToProps, { usuariIntroduccioModificarCamp })(UsuariFormulari);



// WEBPACK FOOTER //
// ./src/components/usuari/usuariFormulari.js